import React, { Suspense } from "react";
import ReactDOM from "react-dom";
/* CSS */

import "./assets/css/customize.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
/* JS */
// import "./assets/vendor/global/global.min.js";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import { createTheme, ThemeProvider } from "@mui/material";
import { registerLicense } from "@syncfusion/ej2-base";
import HeroLoader from "./components/HeroLoader/HeroLoader";
import registerServiceWorker from "./registerServiceWorker";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
registerLicense(
  "ORg4AjUWIQA/Gnt2VVhhQlFaclhJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkNiX39dcnZVRWVeUEY="
);

// Registering Syncfusion license key
registerLicense(
  "ORg4AjUWIQA/Gnt2VVhkQlFadVdJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxQdkRgWX9edXdWQGheUUE="
);

let localStorageSupported = "localStorage" in window;
//this is equal to !!window.localStorage or Boolean(window.localStorage)
if (!localStorageSupported)
  alert(
    "Your browser doesn't supports local storage! Landbook may misbehave. Please change your browser."
  );

/*
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
  */

ReactDOM.render(
  <ErrorBoundary>
    <Suspense fallback={<HeroLoader />}>
      <Provider store={store}>
        <App />
      </Provider>
    </Suspense>
  </ErrorBoundary>,
  document.getElementById("root")
);
registerServiceWorker();
reportWebVitals();
